/**
 * @generated SignedSource<<0a2ee6f3396b3da5ce6dcf59c5b9b456>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebar_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarText_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarLinkBlock_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarUsersGroupRequestLinkBlock_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarEmbed_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarBanner_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarFilesList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarPagesList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarAnalyticsDataList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarEventsList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarParticipativeModuleResults_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarParticipativeModulesList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarCalendar_pageSection"
    }
  ],
  "type": "PageSectionBase",
  "abstractKey": "__isPageSectionBase"
};

node.hash = "1270445d7c89e524fce8b157e38fa6e1";

module.exports = node;
